/**
 * Roles inside a **scaffolding company** (CompanyMember.role).
 *
 * Terminology:
 * - **Scaffolders** = scaffolding **businesses** (directory, signup, admin claim invite).
 * - **Scaff** / **scaffers** = individuals on the tools (`scaff` role here; `CompanyScaffolder` roster).
 * - **Customers** = job posters (unchanged).
 *
 * This is NOT the same as:
 * - **Labour marketplace** = `LabourOperativeProfile` (free profile; Scaff Pro = verified tick + priority).
 * - **PlatformClaimInvite.role `scaffolder`** = creates a new **scaffolding business** (see create-claim-invite).
 */
export const COMPANY_MEMBER_ROLES = [
  "owner",
  "admin",
  "office",
  "supervisor",
  "scaff",
] as const;

export type CompanyMemberRole = (typeof COMPANY_MEMBER_ROLES)[number];

/** Legacy crew role values — normalised to `scaff` in JWT/session */
const LEGACY_CREW_ROLES = new Set(["scaffolder", "field_operative"]);

export function normalizeCompanyMemberRole(role: string): CompanyMemberRole | string {
  if (LEGACY_CREW_ROLES.has(role)) return "scaff";
  return role;
}

export function isCrewOrSupervisorRole(role: string | undefined): boolean {
  if (!role) return false;
  const r = normalizeCompanyMemberRole(role);
  return r === "scaff" || r === "supervisor";
}
